import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';
import { UserState } from './user/user.state';
import { NotificationState } from './notifications/notifications.state';
import { PredictorModelState } from './predictor-model/predictor-model.state';
import { ManagerState } from './manager/manager.state';
import { FeaturesState } from './features/features.state';

export interface ApplicationStateModel {
  name: string;
}

const stateDefaults: ApplicationStateModel = {
  name: 'Debris Flow',
};

@State<ApplicationStateModel>({
  name: 'DebrisFlow',
  defaults: stateDefaults,
  children: [UserState, NotificationState, PredictorModelState, ManagerState, FeaturesState],
})
@Injectable()
export class ApplicationState {
}
